import { AuthContext } from "contexts/AuthProvider";
import { useContext } from "react";
import { useQuery } from "react-query";
import { getRequest } from "./apiClient";
import { IUserInput, IUserOutput } from "../../../api-schema/user";

const USER_ENDPOINT = "user";
const buildUserCacheKey = (uId: string) => [USER_ENDPOINT, uId];

const getUserData = async ({ uId }: IUserInput, token: string) => {
  return await getRequest<IUserOutput>(USER_ENDPOINT, { uId }, token);
};
const useUserData = () => {
  const { uId, token } = useContext(AuthContext);
  const { data, isLoading, isError } = useQuery(buildUserCacheKey(uId), () =>
    getUserData({ uId }, token)
  );

  return { data, isLoading, isError };
};

export default useUserData;
